import type { EnrollmentCredentialUseModel } from '@/adapters/apiv1.g';
import type { EnrollmentCredentialUse } from '@/types/core/enrollment';
import type { UUID } from '@/utils/uuid';

/**
 * Transform a backend EnrollmentCredentialUseModel to the frontend type.
 */
export function extractEnrollmentUse(
  model: EnrollmentCredentialUseModel
): EnrollmentCredentialUse {
  return {
    credentialId: (model.credential_id ?? '') as UUID,
    clientId: (model.client_id ?? '') as UUID,
    hostname: model.hostname ?? '',
    enrolledAt: model.enrolled_at ?? '',
  };
}
